import { render, staticRenderFns } from "./xeWorkflowTree.vue?vue&type=template&id=355e4b72"
import script from "./xeWorkflowTree.vue?vue&type=script&lang=js"
export * from "./xeWorkflowTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports